import { Environment } from "./backendUrl";

export function getEnv(): Environment {
  switch (window.location.hostname) {
    case "my.thoughtworks.net":
      return "prod";
    case "stage.non-prod.my.thoughtworks.net":
      return "stage";
    default:
      return "dev";
  }
}
